var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      class: _vm.cardClasses,
      attrs: { loading: _vm.loading, outlined: "", hover: "" },
      on: {
        mouseover: function ($event) {
          _vm.isHovered = true
        },
        mouseleave: function ($event) {
          _vm.isHovered = false
        },
      },
    },
    [
      _vm.loading
        ? [
            _c("v-skeleton-loader", {
              attrs: {
                type: "card-heading, list-item-avatar-two-line, actions",
                height: "180",
              },
            }),
          ]
        : [
            _vm.isBlocking
              ? _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "activator",
                          fn: function ({ on, attrs }) {
                            return [
                              _c(
                                "v-icon",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "ambience-card__lock",
                                      attrs: { color: "error", size: "20" },
                                    },
                                    "v-icon",
                                    attrs,
                                    false
                                  ),
                                  on
                                ),
                                [_vm._v("mdi-lock")]
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      449101299
                    ),
                  },
                  [
                    _c("span", [
                      _vm._v("Resolva esta sala para liberar o acesso"),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "v-card-title",
              { staticClass: "py-2 d-flex align-center" },
              [
                _vm.selectable
                  ? _c("v-checkbox", {
                      staticClass: "mt-0 mr-2",
                      attrs: {
                        "input-value": _vm.selected,
                        "hide-details": "",
                        dense: "",
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.$emit("update:selected", !_vm.selected)
                        },
                      },
                    })
                  : _vm._e(),
                _c(
                  "v-icon",
                  {
                    attrs: {
                      left: "",
                      color: _vm.occupationColorValue,
                      size: "20",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.ambienceIcon) + " ")]
                ),
                _c(
                  "span",
                  {
                    staticClass: "subtitle-1 font-weight-medium text-truncate",
                  },
                  [_vm._v(" " + _vm._s(_vm.ambience.name) + " ")]
                ),
                _c("v-spacer"),
                _c(
                  "v-chip",
                  {
                    staticClass: "ml-2",
                    attrs: {
                      "x-small": "",
                      color: _vm.occupationColorValue,
                      dark: "",
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.occupationPercentageValue) + "% ")]
                ),
                _vm.criticalSinceLabel
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-chip",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          staticClass: "ml-1",
                                          attrs: {
                                            "x-small": "",
                                            color: "error",
                                            dark: "",
                                          },
                                        },
                                        "v-chip",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c(
                                        "v-icon",
                                        { attrs: { left: "", small: "" } },
                                        [_vm._v("mdi-alert")]
                                      ),
                                      _vm._v(
                                        " Crítico desde " +
                                          _vm._s(_vm.criticalSinceLabel) +
                                          " "
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3705404408
                        ),
                      },
                      [
                        _c("span", [
                          _vm._v("Sala em zona vermelha de forma contínua"),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("v-divider"),
            _c(
              "v-card-text",
              { staticClass: "py-2" },
              [
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c("v-col", { attrs: { cols: "6" } }, [
                      _c(
                        "div",
                        {
                          staticClass: "caption grey--text d-flex align-center",
                        },
                        [
                          _vm._v(" Capacidade "),
                          _vm.capacityModeLabel
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-chip",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass:
                                                      "ml-1 capacity-mode-chip",
                                                    attrs: {
                                                      "x-small": "",
                                                      outlined: "",
                                                    },
                                                  },
                                                  "v-chip",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.capacityModeLabel
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    215631589
                                  ),
                                },
                                [
                                  _c("span", [
                                    _vm._v("Modo de capacidade ativo"),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "body-2 font-weight-medium" }, [
                        _vm._v(
                          " " + _vm._s(_vm.activeCapacityValue) + " lugares "
                        ),
                      ]),
                    ]),
                    _c("v-col", { attrs: { cols: "6" } }, [
                      _c("div", { staticClass: "caption grey--text" }, [
                        _vm._v("Ocupação"),
                      ]),
                      _c("div", { staticClass: "body-2 font-weight-medium" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.occupation.students || 0) +
                            " alunos "
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c("v-progress-linear", {
                  staticClass: "mt-2",
                  attrs: {
                    value: _vm.occupationPercentageValue,
                    color: _vm.occupationColorValue,
                    height: "8",
                    rounded: "",
                  },
                }),
                _vm.hasBalance
                  ? _c(
                      "v-row",
                      { staticClass: "mt-2", attrs: { dense: "" } },
                      [
                        _c("v-col", { attrs: { cols: "6" } }, [
                          _c("div", { staticClass: "caption grey--text" }, [
                            _vm._v("Previsão"),
                          ]),
                          _c("div", { staticClass: "body-2" }, [
                            _vm._v(_vm._s(_vm.occupation.forecast || 0)),
                          ]),
                        ]),
                        _c(
                          "v-col",
                          { attrs: { cols: "6" } },
                          [
                            _c("div", { staticClass: "caption grey--text" }, [
                              _vm._v("Saldo"),
                            ]),
                            _c(
                              "v-chip",
                              {
                                attrs: {
                                  "x-small": "",
                                  color: _vm.balanceColorValue,
                                  "text-color": _vm.balanceTextColor,
                                  outlined: "",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.occupation.balance > 0 ? "+" : ""
                                    ) +
                                    _vm._s(_vm.occupation.balance || 0) +
                                    " "
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.hasResources
                  ? _c(
                      "div",
                      { staticClass: "mt-2" },
                      [
                        _c("sys-ambience-resource-tags", {
                          attrs: {
                            resources: _vm.ambience.resources,
                            "x-small": "",
                            "icon-only": "",
                            "max-display": 5,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.teacher
                  ? _c(
                      "div",
                      {
                        staticClass: "mt-3 d-flex align-center teacher-info",
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.$emit("click:teacher", _vm.teacher)
                          },
                        },
                      },
                      [
                        _c(
                          "v-avatar",
                          {
                            staticClass: "mr-2 cursor-pointer",
                            attrs: { size: "32", color: "grey lighten-2" },
                          },
                          [
                            _vm.teacher.photo
                              ? _c("v-img", {
                                  attrs: { src: _vm.teacher.photo },
                                })
                              : _c("v-icon", { attrs: { color: "grey" } }, [
                                  _vm._v("mdi-account"),
                                ]),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "flex-grow-1 text-truncate" },
                          [
                            _c("div", { staticClass: "caption grey--text" }, [
                              _vm._v("Docente"),
                            ]),
                            _c("div", { staticClass: "body-2 text-truncate" }, [
                              _vm._v(_vm._s(_vm.teacher.name)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("v-divider"),
            _c(
              "v-card-actions",
              { staticClass: "pa-2" },
              [
                _c(
                  "v-tooltip",
                  {
                    attrs: { bottom: "" },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      small: "",
                                      text: "",
                                      color: "primary",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.$emit(
                                          "click:details",
                                          _vm.ambience
                                        )
                                      },
                                    },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", left: "" } },
                                  [_vm._v("mdi-eye")]
                                ),
                                _vm._v(" Detalhes "),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  },
                  [_c("span", [_vm._v("Ver detalhes da sala")])]
                ),
                _c("v-spacer"),
                _vm.showSwapAction
                  ? _c(
                      "v-tooltip",
                      {
                        attrs: { bottom: "" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function ({ on, attrs }) {
                                return [
                                  _c(
                                    "v-btn",
                                    _vm._g(
                                      _vm._b(
                                        {
                                          attrs: {
                                            small: "",
                                            icon: "",
                                            color: _vm.isHovered
                                              ? "orange"
                                              : "grey",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.$emit(
                                                "click:suggest-swap",
                                                _vm.ambience
                                              )
                                            },
                                          },
                                        },
                                        "v-btn",
                                        attrs,
                                        false
                                      ),
                                      on
                                    ),
                                    [
                                      _c("v-icon", { attrs: { small: "" } }, [
                                        _vm._v("mdi-swap-horizontal"),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1185499503
                        ),
                      },
                      [_c("span", [_vm._v("Sugerir troca de sala")])]
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }